function inputChanged (event) {
	const {target} = event;
	const {min, max, current, param} = target.dataset;
	const page = +target.value;

	target.parentElement.classList.remove('has-error');

	if (!page) {
		target.value = current;
		return;
	}

	if (page === +current) {
		return;
	}

	if (page < min || page > max) {
		target.parentElement.classList.add('has-error');
		console.warn(`Out of range: ${page} (min: ${min}, max: ${max})`);
		return;
	}

	const addParams = {};
	addParams[param] = page;
	location.href = BX.util.add_url_param(location.href, addParams);
}

function initSystemPagination (clientID) {
	const inputs = document.querySelectorAll('#'+clientID+'.page-counter .page-counter__number > input');
	[...inputs].forEach((input) => {
		BX.bind(input, 'change', inputChanged);
	});
}
export {initSystemPagination}
